import { useToast as useChakraToast } from '@chakra-ui/react';

type ToastStatus = 'success' | 'error' | 'warning' | 'info';

type ShowToastOptions = {
  title: string;
  description?: string;
  status?: ToastStatus;
};

const useToasts = () => {
  const toast = useChakraToast();

  const showToast = ({ title, description, status = 'info' }: ShowToastOptions) => {
    toast({
      title,
      description,
      status,
      duration: 4000,
      isClosable: true,
      position: 'bottom-right',
    });
  };

  return { showToast };
};

export default useToasts;
